import { BaseResource } from "../resources/BaseResource";
import { deeplyApplyKeyTransform, deeplyApplyValueTransform } from "@ploy-lib/core";
import camelCase from "lodash/camelCase";
import pRetry from "p-retry";
export class BasePlainResource extends BaseResource {
    static endpoint() {
        return this.memo("#endpointPlain", () => {
            return super.endpoint().extend({
                method: "POST"
            });
        });
    }
}
export class BaseCamelCasedResource extends BasePlainResource {
    static async fetch(input, init) {
        const jsonResponse = await super.fetch(input, init);
        const data = deeplyApplyKeyTransform(jsonResponse, camelCase);
        const dataWithoutNull = deeplyApplyValueTransform(data, v => v == null ? undefined : v);
        return dataWithoutNull;
    }
}
export class BaseResourceWithRetry extends BaseResource {
    static async fetch(input, init) {
        const options = {
            retries: 3
        };
        const run = async () => await super.fetch(input, init);
        return await pRetry(run, options);
    }
}
//# sourceMappingURL=BasePlainResource.js.map